import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoriesSection from './components/CategoriesSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorks from './components/HowItWorks';
import SafetySection from './components/SafetySection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { faqItems } from '@/mocks/faq';

const siteUrl = 'https://itaobuyspread.boats';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Itaobuy Spread',
  url: siteUrl,
  logo: logoUrl,
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spreadsheet Italia',
  url: siteUrl,
  description: 'La guida italiana più completa per scoprire, analizzare e utilizzare Itaobuy Spreadsheet. Guide, categorie prodotti, confronti, consigli sicurezza e risorse aggiornate.',
  inLanguage: 'it-IT',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoriesSection />
        <AboutSection />
        <FeaturesSection />
        <HowItWorks />
        <SafetySection />
        <ArticlesSection />
        <TestimonialSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}